import { render, staticRenderFns } from "./SelfAssess.vue?vue&type=template&id=32cba1fa&scoped=true&"
import script from "./SelfAssess.vue?vue&type=script&lang=js&"
export * from "./SelfAssess.vue?vue&type=script&lang=js&"
import style0 from "./SelfAssess.vue?vue&type=style&index=0&id=32cba1fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32cba1fa",
  null
  
)

export default component.exports